<template>
	<div class="col-sm-12 col-md-3">
		<div class="row m-2">
			<div
				:class="`col-12 details-container custom-rounded-15 overflow-hidden ${classes}`"
			>
				<div class="row">
					<div
						class="col-12 mt-2 d-flex justify-content-evenly align-items-center"
					>
						<div class="details-title mb-2 d-flex align-items-center">
							<h4 class="mb-0">{{ name }}</h4>
						</div>
						<div class="d-flex align-items-center">
							<i :class="`${icon} text-lg  fs-3`"></i>
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-center">
						<h1 class="custom-fs-lg">{{ info }}</h1>
					</div>
				</div>
				<div class="row d-flex justify-content-end align-center hover-dark">
					<span
						class="info my-2 d-flex d-flex justify-content-end align-center fs-6 me-1 cursor-pointer"
						@click="$router.push({ name: url, params: {
							slug: name.includes(' ') ? name.split(' ')[0] : name}
						})"
					>	
						See More
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "DashInfoComponent",
		props: {
			name: { type: String, required: true },
			info: { type: [Number, String], default: 0, required: true },
			icon: { type: String, required: true },
			classes: {
				type: String,
				default: "col-4",
			},
			url: { type: String, default: "Leads" },
		},
	};
</script>
<style scoped>
.h4, h4 {
    font-size: 1.1rem;
}
.custom-fs-lg {
    font-size: 2.2rem;
}
.fs-6 {
    font-size: .8rem!important;
}
i{
	font-size: 20px !important;	
	
} 

</style>
